import React from 'react';
import { CustomInput } from 'reactstrap';
import { Dropdown, Input } from '../../../../../UI/Common';
import ReactSelect from '../../../../../UI/ReactSelect';

const SquarePropertiesForm = ({
  values: { position, dimension, ...values },
  handleChange,
  setFieldValue,
  touched,
  errors,
  groups,
}) => {
  function getGroupName(groupId) {
    const index = groups.findIndex((group) => group.id === groupId);
    return groups[index].name;
  }
  return (
    <ReactSelect
      label="Group"
      options={groups}
      value={values.groupId}
      onChange={({ value }) => {
        setFieldValue('groupId', value);
        setFieldValue('groupName', getGroupName(value));
      }}
      valueKey="id"
      labelKey="name"
    />
  );
};

export default SquarePropertiesForm;
